/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { AccountService } from '../user/account.service';
import { finalize, tap } from 'rxjs/operators';
import { ApiErrorService } from '../api-error.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  apiParams: any;

  // tslint:disable-next-line: max-line-length
  // eslint-disable-next-line max-len
  constructor(
    private httpClient: SmartHttpService,
    private helperService: HelperService,
    private envService: TxService,
    private accountService: AccountService,
    private apiErrorService: ApiErrorService,
    private localStorageData: LocalStorageService,
    private location: Location
  ) {
    this.initApiParams();
  }

  public get getLanguage() {
    return this.localStorageData.getItem(localStorageKeys.LANGUAGE);
  }
  public get getCurrency() {
    return this.localStorageData.getItem(localStorageKeys.CURRENCY);
  }

  public get parseBarcodeInfoApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.parseBarcodeInfoApi = `${this.envService.parseBarcodeInfoApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get retailerServicesApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.retailerServicesApi = `${this.envService.getServicesApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get appPageApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.appPageApi = `${this.envService.getAppPageApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get enyuiryFormApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.enyuiryFormApi = `${this.envService.getEnquiryFormApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get sendServiceRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.submitServiceRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get cancelServiceRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.cancelServiceRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get getServiceDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getServiceDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get myServiceRequestsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.myServiceRequestsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get gethomepageApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.gethomepageApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get getFlightsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getFlightsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get getFlightDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getFlightDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get getMyFlightsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getMyFlightsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get getCalenderFlightsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getCalenderFlightsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get saveTrackFlightApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.saveTrackFlightApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get stopTrackFlightApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.stopTrackFlightApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get flightSearchByIdApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.flightSearchByIdApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get flightSearchByRouteApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.flightSearchByRouteApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get verifyMembershipVoucherApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.verifyMembershipVoucherApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get subscribeMembershipApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getSubscribeMembershipApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get getOrderApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getOrderApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get getCancelOrderApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getCancelOrderApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  public get verifyBookingApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.verifyBookingApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get getOfferListApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getOfferListApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get createVoucherRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.createVoucherRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public get cityListApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.sendServiceRequestApi = `${this.envService.getCityListApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set appPageApi(value: string) {}

  public set enyuiryFormApi(value: string) {}

  public set sendServiceRequestApi(value: string) {}

  public set parseBarcodeInfoApi(value: string) {}

  public set retailerServicesApi(value: string) {}
  public getServices(catlogType: string): Observable<any> {
    this.initApiParams();
    this.apiParams.catlogType = catlogType;
    return this.httpClient.getWithErorrHandler(this.retailerServicesApi);
  }

  //TODO: Move Travelx Specific APis to Travelx Service
  public getHomePage(
    tabId: number = 0,
    pageType: string = '',
    city?: string,
    date?: string,
    country?: string,
    productId?: string,
    location?: string,
    page?: number,
    destination?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.city = city || '';
    this.apiParams.country = country || '';
    this.apiParams.date = date || '';
    this.apiParams.version = 2;
    this.apiParams.productid = productId || '';
    this.apiParams.location = location || '';
    this.apiParams.destination = destination || '';
    this.apiParams.page = page || 1;
    this.apiParams.pageType = pageType;
    this.apiParams.sendSelectedTab = 1;
    this.apiParams.tabId = tabId;
    this.apiParams.airport = localStorage.getItem(
      localStorageKeys.SELECTED_AIRPORT_CODE
    );

    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getAppPage(
    tabId: number,
    carouselId: number,
    city: string,
    date: string,
    country?: string,
    productId?: string,
    location?: string,
    page?: number,
    destination?: string,
    cityCountry?: string,
    tabType?: string,
    type?: string,
    pageType?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.tabId = tabId;
    this.apiParams.carouselId = carouselId;
    this.apiParams.city = city;
    this.apiParams.country = country || '';
    this.apiParams.date = date;
    this.apiParams.version = 2;
    this.apiParams.productid = productId || '';
    this.apiParams.location = location || '';
    this.apiParams.destination = destination || '';
    this.apiParams.cityCountry = cityCountry || '';
    this.apiParams.tabType = tabType || '';
    this.apiParams.page = page || 1;
    this.apiParams.isLive = 1;
    this.apiParams.type = type || '';
    this.apiParams.pageType = pageType || '';
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getLounges(
    tabId: number,
    carouselId: number,
    airport: string,
    location?: string,
    page?: number,
    latitude?: any,
    longitude?: any,
    searchQuery?: any,
    selectedSort?: string,
    selectedFilter?: string,
    carouselType?: string,
    cityCountry?: string,
    tabType?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.tabId = tabId;
    this.apiParams.carouselId = carouselId;
    this.apiParams.carouselType = carouselType || '';
    this.apiParams.airport = airport;
    this.apiParams.page = page || 1;
    this.apiParams.version = 2;
    this.apiParams.location = location || '';
    this.apiParams.latitude = latitude || '';
    this.apiParams.longitude = longitude || '';
    this.apiParams.searchQuery = searchQuery || '';
    this.apiParams.sortBy = selectedSort || '';
    this.apiParams.filters = JSON.stringify(selectedFilter) || '';
    this.apiParams.cityCountry = cityCountry || '';
    this.apiParams.tabType = tabType || '';
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getDutyFreeData(
    tabId: number,
    carouselId: number,
    airport: string,
    location?: string,
    page?: number
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.tabId = tabId;
    this.apiParams.carouselId = carouselId;
    this.apiParams.airport = airport;
    this.apiParams.page = page;
    this.apiParams.version = 2;
    this.apiParams.location = location || '';
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getEnquiryForm(catlogType: string): Observable<any> {
    this.apiParams.catlogType = catlogType;
    return this.httpClient.getWithErorrHandler(this.enyuiryFormApi);
  }
  public getMyServiceRequests(
    page: number,
    perpage?: number,
    requestId?: string,
    showUpcoming?: number
  ): Observable<any> {
    this.apiParams.page = page;
    this.apiParams.count = perpage || 25;
    this.apiParams.requestId = requestId || '';
    this.apiParams.showUpcoming = showUpcoming || 0;
    return this.httpClient.getWithErorrHandler(this.myServiceRequestsApi);
  }

  public cancelServiceRequest(requestId): Observable<any> {
    this.apiParams.request_id = requestId;
    this.apiParams.perpage = 25;
    return this.httpClient.getWithErorrHandler(this.cancelServiceRequestApi);
  }

  public submitServiceRequest(
    data,
    catlogType?: string,
    price?: number,
    clientCode?: string
  ): Observable<any> {
    const origin = location.origin;
    this.apiParams.redirect_url = origin + this.location.path();
    if (catlogType) {
      this.apiParams.catlogType = catlogType;
    }
    if (price) {
      this.apiParams.origPrice = price;
    }
    if (clientCode) {
      this.apiParams.clientCode = clientCode;
    }
    const token = this.accountService.token;
    const isInsuranceType =
      catlogType === 'intl_travel_ins' || catlogType === 'travel_ins' || catlogType === 'trip_insurance';

    const headers = isInsuranceType
      ? this.envService.getMultipartFormHeaders(token)
      : undefined;

    return this.httpClient.postWithErorrHandler(
      this.sendServiceRequestApi,
      data,
      headers
    );
  }

  public getServiceDetail(serviceId): Observable<any> {
    this.apiParams.serviceId = serviceId;
    return this.httpClient.getWithErorrHandler(this.getServiceDetailApi);
  }

  public getMembershipBenefits(
    page?: number,
    perPage?: number
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.page = page;
    this.apiParams.perpage = perPage || 10;
    this.apiParams.tabId = 79;
    this.apiParams.carouselId = 0;
    this.apiParams.version = 2;
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getMyMembership(): Observable<any> {
    this.initApiParams();
    this.apiParams.tabId = 90;
    this.apiParams.carouselId = 0;
    this.apiParams.version = 2;
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getMembershipBenefitDetail(campaignId?: number): Observable<any> {
    this.initApiParams();
    this.apiParams.tabId = 79;
    this.apiParams.carouselId = 0;
    this.apiParams.version = 2;

    if (isNaN(campaignId)) {
      this.apiParams.campaignSlug = campaignId;
    } else {
      this.apiParams.campaignId = campaignId;
    }
    return this.httpClient.getWithErorrHandler(this.appPageApi);
  }

  public getAirportHome(airport: string): Observable<any> {
    this.initApiParams();
    this.apiParams.num = 30;
    this.apiParams.version = 2;
    this.apiParams.tabId = 89;
    this.apiParams.airport = airport;
    const latlongData = JSON.parse(
      localStorage.getItem(localStorageKeys.LAT_LONG_DATA)
    );
    if (latlongData != null) {
      this.apiParams.lat = latlongData?.latitude || 0;
      this.apiParams.lon = latlongData?.longitude || 0;
    }
    return this.httpClient.getWithErorrHandler(this.gethomepageApi);
  }

  public getFlights(
    airport: string,
    type: number,
    page: number
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.type = type;
    this.apiParams.airport = airport;
    this.apiParams.page = page;
    this.apiParams.perpage = 15;
    return this.httpClient.getWithErorrHandler(this.getFlightsApi);
  }

  public getFlightDetail(
    flightid: string,
    origin: string,
    dest: string,
    ondate?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.flightid = flightid;
    this.apiParams.origin = origin;
    this.apiParams.dest = dest;
    this.apiParams.ondate = ondate || '';
    return this.httpClient.getWithErorrHandler(this.getFlightDetailApi);
  }
  public getMyFlights(): Observable<any> {
    this.initApiParams();
    return this.httpClient.getWithErorrHandler(this.getMyFlightsApi);
  }

  public getCalenderFlights(): Observable<any> {
    this.initApiParams();
    // this.apiParams.deviceid = this.accountService.deviceID;
    return this.httpClient.getWithErorrHandler(this.getCalenderFlightsApi);
  }

  public saveTrackFlight(
    flightid: string,
    source: string,
    dest: string,
    ondate: string,
    datetime: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.flightid = flightid;
    this.apiParams.source = source;
    this.apiParams.dest = dest;
    this.apiParams.ondate = ondate;
    this.apiParams.datetime = datetime;
    return this.httpClient.getWithErorrHandler(this.saveTrackFlightApi);
  }

  public stopTrackFlight(trackid: string): Observable<any> {
    this.initApiParams();
    this.apiParams.trackid = trackid;
    return this.httpClient.getWithErorrHandler(this.stopTrackFlightApi);
  }

  public flightSearchById(flightid: string, ondate: string): Observable<any> {
    this.initApiParams();
    this.apiParams.flightid = flightid;
    this.apiParams.ondate = ondate;
    return this.httpClient.getWithErorrHandler(this.flightSearchByIdApi);
  }

  public flightSearchByRoute(
    source: string,
    dest: string,
    ondate: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.source = source;
    this.apiParams.dest = dest;
    this.apiParams.ondate = ondate;
    return this.httpClient.getWithErorrHandler(this.flightSearchByRouteApi);
  }

  public parseBarcodeInfo(data: string): Observable<any> {
    this.initApiParams();
    this.apiParams.return_type = 'legno';
    return this.httpClient
      .post(this.parseBarcodeInfoApi, { barcodeInfo: data })
      .pipe(
        tap(
          (event: HttpEvent<any>) => event,
          (error: any) => {
            this.apiErrorService.updateValue(true);
          }
        )
      );
  }

  public verifyMembershipVoucher(
    voucherCode?: string,
    authToken?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.voucherCode = voucherCode;
    const headers = authToken
      ? this.envService.getHeaders(authToken)
      : undefined;
    return this.httpClient.get(this.verifyMembershipVoucherApi, headers);
  }

  public subscribeMembership(
    voucherCode: string,
    transactionInfo: any
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.voucherCode = voucherCode;
    this.apiParams.transactionId = transactionInfo?.id;
    return this.httpClient.post(this.subscribeMembershipApi, transactionInfo);
  }

  public getOrder(orderId: number): Observable<any> {
    this.initApiParams();
    this.apiParams.orderid = orderId;
    return this.httpClient.getWithErorrHandler(this.getOrderApi);
  }

  public getCancelOrder(orderId: number): Observable<any> {
    this.initApiParams();
    this.apiParams.orderid = orderId;
    return this.httpClient.getWithErorrHandler(this.getCancelOrderApi);
  }

  public getOfferList(
    serviceType: string,
    price: any,
    serviceId?: string,
    location?: string,
    airportCode?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.serviceType = serviceType;
    this.apiParams.price = price;
    this.apiParams.serviceId = serviceId || null;
    if (location) {
      this.apiParams.location = location || null;
    }
    if (airportCode) {
      this.apiParams.airportCode = airportCode || null;
    }
    return this.httpClient.get(this.getOfferListApi);
  }
  public createVoucherRequest(
    campaignId: number,
    serviceId: string = '',
    serviceType: string = ''
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.campaignId = campaignId;
    this.apiParams.serviceId = serviceId;
    this.apiParams.catlogType = serviceType;
    return this.httpClient.getWithErorrHandler(this.createVoucherRequestApi);
  }

  public getCityList(q: string, page: number, size?: number): Observable<any> {
    this.initApiParams();
    this.apiParams.q = q;
    this.apiParams.page = page;
    this.apiParams.size = size || 10;
    return this.httpClient.get(this.cityListApi);
  }

  public verifyBooking(
    catlogType: string,
    paymentIntentId: string,
    paymentSessionId?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.catlogType = catlogType;
    // this.apiParams.paymentIntentId = paymentIntentId;
    // this.apiParams.paymentSessionId = paymentSessionId;
    return this.httpClient.post(this.verifyBookingApi,{
      paymentIntentId: paymentIntentId,
      paymentSessionId: paymentSessionId,
    });
  }

  initApiParams() {
    this.apiParams = {
      page: 1,
      perpage: 10,
      city: '',
    };
    const latLongData = JSON.parse(
      localStorage.getItem(localStorageKeys.LAT_LONG_DATA)
    );
    if (latLongData) {
      this.apiParams.lat = latLongData?.latitude;
      this.apiParams.lon = latLongData?.longitude;
    }
  }
}
